import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.parental_code_reset';
export const Component = loadable(
  () => import('./containers/ParentalCodeResetContainer')
);
export { default as propsFormatter } from './propsFormatter';
